<div class="empty-box">
    <img src="assets/img/open-box.svg" alt="">
    <span> {{title}} وجود ندارد.</span>
</div>